import React from "react";

const LocationIcon = () => (<svg width="48" height="48" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
  <g clipPath="url(#clip0_4473_910)">
    <circle cx="24" cy="24" r="23.5" fill="#F3F3FF" stroke="#DEDFFF" />
    <path d="M15 17C15 15.8954 15.8954 15 17 15H23C24.1046 15 25 15.8954 25 17V33H15V17Z" fill="#B3B7FF" />
    <path d="M29.8 23H25V33H33V26.2C33 25.0799 33 24.5198 32.782 24.092C32.5903 23.7157 32.2843 23.4097 31.908 23.218C31.4802 23 30.9201 23 29.8 23Z" fill="#FFCFDA" />
    <path d="M25 23H29.8C30.9201 23 31.4802 23 31.908 23.218C32.2843 23.4097 32.5903 23.7157 32.782 24.092C33 24.5198 33 25.0799 33 26.2V33" stroke="#EF4068" strokeLinecap="round" strokeLinejoin="round" />
    <path d="M25 33V18.2C25 17.0799 25 16.5198 24.782 16.092C24.5903 15.7157 24.2843 15.4097 23.908 15.218C23.4802 15 22.9201 15 21.8 15H18.2C17.0799 15 16.5198 15 16.092 15.218C15.7157 15.4097 15.4097 15.7157 15.218 16.092C15 16.5198 15 17.0799 15 18.2V33M34 33H14M18.5 19H21.5M18.5 23H21.5M18.5 27H21.5" stroke="#4548C4" strokeWidth="1.3" strokeLinecap="round" strokeLinejoin="round" />
  </g>
  <defs>
    <clipPath id="clip0_4473_910">
      <rect width="48" height="48" fill="white" />
    </clipPath>
  </defs>
</svg>
);

export default LocationIcon;
